import React, { useEffect, useState } from "react";
import { History } from "lucide-react";
import api from "../lib/api";
import { Card, PageHeader, PageLoader, Badge, EmptyState } from "../lib/ui";
import { ROLE_LABELS } from "../lib/constants";
import { useT } from "../lib/i18n";

export default function Audit() {
  const { t } = useT();
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/audit-logs").then(({ data }) => setLogs(data)); }, []);
  if (!logs) return <PageLoader />;

  return (
    <div className="animate-fade-up">
      <PageHeader title={t("Audit Timeline")} subtitle={t("Every action, fully tracked")} icon={History} />
      {logs.length === 0 ? (
        <EmptyState title={t("No activity yet")} subtitle={t("Actions across the platform will be logged here.")} />
      ) : (
        <Card className="p-5">
          <div className="relative space-y-5 before:absolute before:left-[19px] before:top-2 before:h-full before:w-px before:bg-line">
            {logs.map((l) => (
              <div key={l.id} className="relative flex gap-4" data-testid="audit-row">
                <div className="z-10 flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary-light text-xs font-bold text-primary">
                  {l.user_name?.[0] || "?"}
                </div>
                <div className="flex-1 pb-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="font-semibold text-ink">{l.user_name}</span>
                    <Badge tone="mute">{t(ROLE_LABELS[l.user_role] || l.user_role)}</Badge>
                    <span className="text-sm font-medium text-primary">{l.action.replace(/_/g, " ")}</span>
                  </div>
                  <p className="text-sm text-ink-soft">{l.entity}{l.detail ? ` · ${l.detail}` : ""}</p>
                  <p className="text-xs text-ink-mute">{(l.created_at || "").slice(0, 19).replace("T", " ")}</p>
                </div>
              </div>
            ))}
          </div>
        </Card>
      )}
    </div>
  );
}
